import { colors, Flex } from "@biblioteksentralen/react";
import { FlexPropsWithoutAnimation, useTransitionProps } from "../utils";

type Props = { date: number; color?: string } & FlexPropsWithoutAnimation;

export const CalendarDoorNumber = ({ date, color = colors.black, ...flexProps }: Props) => {
  const transitionProps = useTransitionProps();

  return (
    <Flex
      background="white"
      borderRadius="50%"
      width={{ base: "2.1rem", sm: "2.6rem", md: "2.8rem", lg: "3rem" }}
      height={{ base: "2.1rem", sm: "2.6rem", md: "2.8rem", lg: "3rem" }}
      fontSize={{ base: "2xl", md: "3xl" }}
      fontWeight="600"
      justifyContent="center"
      alignItems="center"
      color={color}
      {...flexProps}
      {...transitionProps}
    >
      {date}
    </Flex>
  );
};
